import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const STORAGE_KEY = 'cookie_consent';
const PRIVACY_POLICY_URL = 'https://mui.com/legal/privacy/';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const savedConsent = window.localStorage.getItem(STORAGE_KEY);

    if (!savedConsent) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (value) => {
    window.localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        insetInline: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        px: { xs: 2, sm: 3 },
        pb: { xs: 2, sm: 3 }
      }}
    >
      <Paper
        elevation={12}
        sx={{
          width: 'min(100%, 960px)',
          mx: 'auto',
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          boxShadow: '0 -4px 24px rgba(15, 23, 42, 0.12)'
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 3 }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 2.5 } }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
              We use cookies
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
              We use cookies to improve site performance, analyse traffic, and personalise content. By selecting{' '}
              <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                Accept All
              </Box>{' '}
              you consent to the use of cookies.{' '}
              <Link href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer" underline="hover">
                Learn more
              </Link>
            </Typography>
          </Box>

          <Stack direction="row" spacing={1.5} sx={{ width: { xs: '100%', md: 'auto' } }}>
            <Button
              fullWidth
              variant="outlined"
              color="inherit"
              onClick={() => handleConsent('declined')}
              sx={{ minWidth: { md: 120 }, borderColor: 'divider' }}
            >
              Decline
            </Button>
            <Button fullWidth variant="contained" onClick={() => handleConsent('accepted')} sx={{ minWidth: { md: 140 } }}>
              Accept All
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}